import * as Services from '../services';

export default {
  /**
   *
   * @param files
   * @param commit
   * @returns {Promise<*>}
   */
  async fetchTriggers({ commit }) {
    const response = await Services.fetchTriggers();
    commit('setProperty', { property: 'triggers', payload: response });
  },

  /**
   *
   * @param commit
   * @param id
   * @returns {Promise<void>}
   */
  async fetchTriggerSettings({ commit }, { id }) {
    const response = await Services.fetchTriggerSettings(id);
    commit('setProperty', { property: 'settings', payload: response });
  },

  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchDrivers({ commit }) {
    const response = await Services.fetchDrivers();
    commit('setProperty', { property: 'drivers', payload: response });
  },

  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchTemplates({ commit }) {
    const response = await Services.fetchTemplates();
    commit('setProperty', { property: 'templates', payload: response });
  },

  /**
   *
   * @param context
   * @param payload
   * @returns {Promise<AxiosResponse<*>>}
   */
  async createTrigger({ dispatch }, payload) {
    await Services.createTriggers(payload);
    dispatch('fetchTriggers');
  },

  /**
   *
   * @param dispatch
   * @param payload
   * @param id
   * @returns {Promise<void>}
   */
  async updateTrigger({ dispatch }, { payload, id }) {
    await Services.updateTrigger(id, payload);
    dispatch('fetchTriggers');
  },

  /**
   *
   * @param dispatch
   * @param id
   * @returns {Promise<void>}
   */
  async deleteTrigger({ dispatch }, id) {
    await Services.deleteTrigger(id);
    dispatch('fetchTriggers');
  },
};
